var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.20039C3.5 5.93765 3.5 4.80628 4.23223 4.10333C4.96447 3.40039 6.14297 3.40039 8.5 3.40039H11C13.357 3.40039 14.5355 3.40039 15.2677 4.10333C16 4.80628 16 5.93765 16 8.20039V12.2004C16 14.4631 16 15.5945 15.2677 16.2974C14.5355 17.0004 13.357 17.0004 11 17.0004H8.5C6.14297 17.0004 4.96447 17.0004 4.23223 16.2974C3.5 15.5945 3.5 14.4631 3.5 12.2004V8.20039Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14.6C2.11929 14.6 1 13.5255 1 12.2V7.4C1 4.38301 1 2.87452 1.97631 1.93726C2.95262 1 4.52397 1 7.66667 1H11C12.3807 1 13.5 2.07452 13.5 3.4",
    stroke: "currentColor",
    strokeWidth: 1.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.6e32196cfcdad4ed90f2d42aa254d085.svg";
export { ForwardRef as ReactComponent };